var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "taskMultiSources" } }, [
        _c("div", { staticClass: "title" }, [
          _vm.type == 2
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("language.common.target") +
                      "(" +
                      _vm.sources.length +
                      ")"
                  )
                )
              ])
            : _c("span", [
                _vm._v(_vm._s("Source(" + _vm.sources.length + ")"))
              ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "multi-sources-body" }, [
          _c(
            "ul",
            { staticStyle: { overflow: "auto" } },
            _vm._l(_vm.sources, function(source, index) {
              return _c(
                "li",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toCatalog(source)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "clouds_logo clouds_logo_22",
                    class: source.driveType
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "multi-source-path",
                      attrs: {
                        title: _vm._f("getCatalogTitle")(
                          _vm.getCatalog(source.nodes)
                        )
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.getCatalog(source.nodes)) +
                          "\n                    "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0026b4c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0026b4c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/task_multi_sources_popup.vue
// module id = null
// module chunks = 